// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3FGzJ","modalFooterButton":"ModalNotes_modalFooterButton__TaTfV"};